<template>
    <div class="home">
        <div class="fixed header">
            <img class="header_logo" src="../assets/images/logo.png" alt="" />
            <div
                v-for="item in tabList"
                :key="item.key"
                class="header_tabs"
                :class="{
                    header_tabs_active: checkedTab.key == item.key,
                }"
                @click="routeTo(item)"
            >
                <a :href="getUrl(item)" style="color: #fff">
                    {{ item.name }}
                </a>
            </div>
            <div class="right_title">欢迎来到沣桓科技服务中心！</div>
        </div>
        <router-view />
        <div class="footer">
            <div class="footer_list">
                <div class="footer_item">
                    <div class="size_16">快捷入口</div>
                    <div
                        v-for="item in tabList"
                        :key="item.key"
                        class="size_14"
                        @click="routeTo(item)"
                    >
                        <a :href="getUrl(item)" style="color: #fff">
                            {{ item.name }}
                        </a>
                    </div>
                </div>
                <div class="footer_item">
                    <div class="size_16">公司产品</div>
                    <div class="size_14 space special_item">司福御APP</div>
                    <div class="size_14 space special_item">幸福驾道APP</div>
                </div>
                <div class="footer_item">
                    <div class="size_16">关于我们</div>
                    <div class="size_14">服务条款</div>
                    <div class="size_14">联系我们</div>
                </div>
            </div>

            <div class="qrcode">
                <img src="../assets/images/home/sifuyu_logo.png" alt="" />
                <img src="../assets/images/home/qrcode.png" alt="" />
            </div>
        </div>
        <div class="copyright">
            <div>
                Copyright &copy; 2022 - 2023 杭州沣桓科技有限公司 版权所有
            </div>
            <div>
                <a href="https://beian.miit.gov.cn" target="_blank">
                    <u>浙ICP备2022003217号-1</u>
                </a>
            </div>
            <div style="margin: 0 40px">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007077">
                    <img src="../assets/images/home/beian.png" style="width:15px;float:left;"/>
                    <u>浙公网安备 33010502007077号</u>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            tabList: [
                { key: 1, path: "/summary", name: "首页", url: "" },
                { key: 2, path: "/profile", name: "公司简介", url: "/profile" },
                {
                    key: 3,
                    path: "/summary",
                    name: "公司服务",
                    url: "#company1",
                },
                { key: 4, path: "/summary", name: "产品介绍", url: "#company2" },
                { key: 5, path: "/about", name: "关于我们", url: "/about" },
            ],
            checkedTab: { key: 1, path: "/summary", name: "首页" },
        };
    },
    methods: {
        routeTo(item) {
            this.checkedTab = item;
            let path = this.$route.path;
            if (path == item.path) {
                return;
            }
            this.$router.push(item.path);
        },
        getUrl(item) {
            if (this.checkedTab.path == "/summary") {
                return item.url;
            } else {
                return false;
            }
        },
    },
};
</script>
<style scoped>
.header {
    top: 0;
    z-index: 10;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    display: flex;
    align-items: center;
}
.header_logo {
    width: 146px;
    margin: 12px 0 12px 376px;
}
.header_tabs {
    width: 96px;
    color: #fff;
    opacity: 0.6;
    margin-right: 48px;
    font-size: 16px;
    cursor: pointer;
}
.header_tabs_active {
    opacity: 1;
}
.header > .header_tabs:first-of-type {
    margin-left: 30px;
}
.right_title {
    margin-left: auto;
    /* margin-right: 311px; */
    margin-right: 250px;
    font-size: 14px;
}
.footer {
    background: url(../assets/images/home/footer_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}
.footer_list {
    display: flex;
    margin: 54px 0 54px 432px;
}
.footer_item {
    text-align: left;
    cursor: pointer;
}
.footer_item > .size_16 {
    margin-bottom: 20px;
}
.footer_item > .size_14 {
    margin-bottom: 12px;
}
.footer_item > .size_14:last-child {
    margin-bottom: 0;
}
.footer_item:nth-of-type(2) {
    margin-left: 90px;
    margin-right: 90px;
}
.special_item {
    text-shadow: 0px 2px 10px rgba(254, 167, 79, 0.3);
    background: linear-gradient(270deg, #ffc66d 0%, #ff943b 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.qrcode {
    margin-right: 446px;
}
.qrcode > img:first-child {
    width: 67px;
    margin: 0 auto 10px;
}
.qrcode > img:nth-child(2) {
    width: 100px;
}
.copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 0;
    background: #fff;
    color: #333;
}
.copyright > div:first-child {
    margin-right: 80px;
}
.size_14 {
    font-size: 14px;
}
.size_16 {
    font-size: 16px;
}
/* @media screen and (max-width: 1024px) {
    .size_16 {
        font-size: 13px;
    }
    .size_14 {
        font-size: 11px;
    }
}
@media screen and (min-width: 1024px) and (max-width: 1366px) {
    .size_16 {
        font-size: 14px;
    }
    .size_14 {
        font-size: 12px;
    }
}
@media screen and (min-width: 1366px) and (max-width: 1680px) {
    .size_16 {
        font-size: 15px;
    }
    .size_14 {
        font-size: 13px;
    }
}
@media screen and (min-width: 1680px) {
    .size_16 {
        font-size: 16px;
    }
    .size_14 {
        font-size: 14px;
    }
} */
</style>
